module.exports = __webpack_public_path__ + "static/media/chloe-fleur-big.2dc9bd65.png";